module.exports = __webpack_public_path__ + "static/media/consulting.5b8c4488.svg";